export enum FreewallBranding {
    Rezonence = 'Rezonence',
    YouGov = 'YouGov'
}
